import { useAtomValue } from 'jotai'
import { blossomChannelAtom } from '@/atoms/invalidation'
import { toBlossom } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import { loadBlossomServers } from '@nostr/gadgets/lists'
import { useTranslation } from 'react-i18next'
import { useAsync } from 'react-use'

export default function BlossomServers({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const channel = useAtomValue(blossomChannelAtom)
  const { value: servers, loading } = useAsync(async () => {
    const rl = await loadBlossomServers(pubkey)
    return rl.items
  }, [pubkey, channel])

  return (
    <SecondaryPageLink
      to={toBlossom(pubkey)}
      className="flex gap-1 hover:underline w-fit items-center text-xs"
    >
      {loading ? (
        <HugeiconsIcon icon={Loading03Icon} className="animate-spin size-3" />
      ) : (
        (servers?.length ?? 0)
      )}
      <div className="text-muted-foreground">{t('Blossom')}</div>
    </SecondaryPageLink>
  )
}
